import { Component } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-unsaved-changes-warning',
  standalone: false,
  templateUrl: './unsaved-changes-warning.component.html',
  styleUrl: './unsaved-changes-warning.component.scss'
})
export class UnsavedChangesWarningComponent {
  constructor(private dialogRef: NzModalRef<UnsavedChangesWarningComponent>) { }

  public onSubmit(): void {
    this.dialogRef.close(true);
  }

  public onCancel(): void {
    this.dialogRef.close(false);
  }
}
